declare global {
  interface Window {
    dataLayer: any;
  }
}

const trackCartProductProtectionUserSelected = data => {
  const event = 'cart_product_protection_user_selected'

  const logData = {
    event,
    ...data,
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(logData)
}

export default trackCartProductProtectionUserSelected
